<template>
  <v-card flat>
    <v-toolbar
      flat
      dense
      dark
      color="secondary"
    >
      <v-spacer />
      <v-toolbar-title v-text="$t('animation.multiproject.criticalResource.title')" />
      <v-spacer />
    </v-toolbar>

    <v-card-text class="pt-3">
      <v-item-group v-model="internalValue">
        <v-row justify="center" align="center">
          <v-col
            v-for="resource in game.resourceList"
            :key="`resource-${resource.color}`"
            cols="12"
            md="6"
          >
            <v-item
              v-slot:default="{ active, toggle }"
              :value="resource.color"
            >
              <v-card
                :color="$options.colors[resource.color]"
                :flat="!active"
                :elevation="active ? 24 : 0"
                dark
                style="max-width: 400px"
                class="d-flex align-center mx-auto"
                height="45"
                @click="toggle"
              >
                <v-overlay v-if="!active" absolute />
                <div class="headline flex-grow-1 text-center" v-text="resource.name" />
                <v-icon
                  large
                  class="mr-4"
                  v-text="active ? 'mdi-check-box-outline' : 'mdi-checkbox-blank-outline'"
                />
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-spacer />
      <ag-confirm-dialog
        :title="$t('general.confirmation')"
        :message="$t('animation.multiproject.criticalResource.confirmMessage', {
          name: selectedResourceName,
        })"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.validate')"
        validation-btn-color="accent"
        @confirm="$emit('input', internalValue)"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loading"
            :disabled="!internalValue"
            color="accent"
            v-bind="attrs"
            v-on="on"
            v-text="$t('animation.multiproject.criticalResource.confirmButton')"
          />
        </template>
      </ag-confirm-dialog>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'

export default {
  name: 'CriticalResourceSelect',
  components: {
    AgConfirmDialog,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    game: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    internalValue: null,
  }),
  computed: {
    selectedResourceName () {
      const selectedResource = this.game.resourceList
        .find(item => item.color === this.internalValue)

      return selectedResource?.name
    },
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.internalValue = this.value
      },
    },
  },
  colors: {
    red: 'red',
    green: 'green',
    yellow: 'amber',
    blue: 'indigo',
  },
}
</script>
